import * as React from "react";
import { forwardRef } from "react";
const SvgAdSite = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", stroke: "#0078D4", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, viewBox: "0 0 24 24", width: "1em", height: "1em", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" }), /* @__PURE__ */ React.createElement("path", { d: "M9 22V12h6v10" }), /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 7, r: 1, fill: "#0078D4" }));
const ForwardRef = forwardRef(SvgAdSite);
export default ForwardRef;
